import gql from 'graphql-tag'

export const newPolicyReportRule = gql`
  mutation($input: NewPolicyReportRuleInput!) {
    newPolicyReportRule(
      input: $input
    ) {
      id
      name
      displayColumns
      orderBy
      asc
      bindDate
      effectiveDate
      expirationDate
      cancelDate
      gaCondition
      gaConditionValue
      carrierCondition
      carrierConditionValue
      sourceCondition
      sourceConditionValue
      insuranceProductCondition
      insuranceProductConditionValue
      recordTypeCondition
      recordTypeConditionValue
      policyTypeCondition
      policyTypeConditionValue
      nonRenew
      createdAt
      updatedAt
    }
  }
`

export const editPolicyReportRule = gql`
  mutation($input: EditPolicyReportRuleInput!, $policyReportRuleId: Int!) {
    editPolicyReportRule(
      input: $input
      policyReportRuleId: $policyReportRuleId
    ) {
      id
      name
      displayColumns
      orderBy
      asc
      bindDate
      effectiveDate
      expirationDate
      cancelDate
      gaCondition
      gaConditionValue
      carrierCondition
      carrierConditionValue
      sourceCondition
      sourceConditionValue
      insuranceProductCondition
      insuranceProductConditionValue
      recordTypeCondition
      recordTypeConditionValue
      policyTypeCondition
      policyTypeConditionValue
      nonRenew
      createdAt
      updatedAt
    }
  }
`

export const deletePolicyReportRuleById = gql`
  mutation($policyReportRuleId: Int!) {
    deletePolicyReportRuleById(
      policyReportRuleId: $policyReportRuleId
    )
  }
`

export const getAllPolicyReportRules = gql`
  query {
    getAllPolicyReportRules {
      id
      name
      displayColumns
      orderBy
      asc
      bindDate
      effectiveDate
      expirationDate
      cancelDate
      gaCondition
      gaConditionValue
      carrierCondition
      carrierConditionValue
      sourceCondition
      sourceConditionValue
      insuranceProductCondition
      insuranceProductConditionValue
      recordTypeCondition
      recordTypeConditionValue
      policyTypeCondition
      policyTypeConditionValue
      nonRenew
      createdAt
      updatedAt
    }
  }
`

export const getCustomPoliciesReport = gql`
  query($paging: PagingQuery, $order: PoliciesOrder, $ruleId: Int!) {
    getCustomPoliciesReport(
      paging: $paging,
      order: $order,
      ruleId: $ruleId
    ) {
      policies {
        id
        cancelDate
        policyName
        status
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        type
        closed
        bindDate
        payerType
        nonRenew
        createdAt
        updatedAt
        productCommissionOverride
        additionalInfoStr
        billingType
        isPremiumPayOff
        isCommissionPayOff
        billingType
        totalProjectedCommission
        totalProjectedPremium
        totalPremiumReceived
        totalCommissionReceived
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
        source {
          id
          name
        }
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        account {
          id
          name
          producers {
            id
            username
          }
        }
        primaryContact {
          id
          name
        }
        payments {
          id
          amount
          receivedDate
          status
          notes
          createdAt
          updatedAt
        }
        commissions {
          id
          amount
          receivedDate
          status
          notes
          createdAt
          updatedAt
        }
        generalAgent {
          id
          name
        }
      }
      totalProjectedPremium
      totalCommissionReceived
      totalProjectedCommission
      paging {
        totalCount
        currentOffset
        currentLimit
      }
      displayColumns
      orderBy
      asc
    }
  }
`

export const exportCustomPolicyReports = gql`
  mutation($ruleId: Int!) {
    exportCustomPolicyReports(
      ruleId: $ruleId
    )
  }
`
